import { useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";
import Input from "../components/Input";
import ErrorIcon from "../icons/ErrorIcon";
import { placeholderImageUrl, publicUrl } from "../utils/url";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';

import './TechnicalCardModal.scss';
import { BREAKPOINT_MD } from "../stores/constants";
import InfoBar from "../components/InfoBar";

import FabricCollectionModel from "../models/FabricCollectionModel";
import TechnicalIcon from "../components/TechnicalIcon.jsx";
import { _t } from '../utils/Lang';

const TechnicalCardModal = observer(({ category }: { category?: FabricCollectionModel }) => {
    const breakpoints = {
        [BREAKPOINT_MD]: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    };
    console.log({ breakpoints });


    return (
        <Modal
            className="TechnicalCardModal modal-xl"
            onClose={e => {
                store.closeTechnicalCardPopup();
            }}
            isOpen={store.isTechnicalCardOpen}

        >
            <div className="c-h1">{category?.name}</div>
            <div className="TechnicalCardModal__icons d-flex my-4">
                {category?.fabricProperties.map(property => (
                    <TechnicalIcon key={property.id} name={property.iconName} />
                ))}

            </div>

            <div className="row gx-4">
                <div className="col-12 col-md-8">
                    <div className="TechnicalCardModal__table">
                        {
                            category?.description ? (
                                <div className="TechnicalCardModal__table-row">
                                    <div className="TechnicalCardModal__table-label">
                                        {_t('description')}
                                    </div>
                                    <div className="TechnicalCardModal__table-val text-start">
                                        {category?.description}
                                    </div>
                                </div>

                            ) : null
                        }
                        {
                            category?.technicalCardProperties.map(property => (
                                <div key={property.id} className="TechnicalCardModal__table-row">
                                    <div className="TechnicalCardModal__table-label">
                                        {property.name}
                                    </div>
                                    <div className="TechnicalCardModal__table-val text-start">
                                        {property.value}
                                    </div>
                                </div>
                            ))
                        }
                        {category?.technicalCardProperties.length === 0 && (
                            <div className="TechnicalCardModal__table-row">
                                <div className="TechnicalCardModal__table-label">
                                    {_t('no_data')}
                                </div>
                            </div>
                        )}

                        {/* <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Opis
                            </div>
                            <div className="TechnicalCardModal__table-val text-start">
                                Tkanina Puente to nowoczesna plecionka obiciowa, która charakteryzuje się grubym, wyczuwalnym splotem oraz ziarnistą teksturą. Jest to trwały i wytrzymały materiał, często o większej gramaturze, co czyni go odpornym na rozciąganie i uszkodzenia.
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Gramatura
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                500g/m² +/- 5%
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Skład
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                95%PESS%CO
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Test martindale
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                &gt;100000
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Skłonność do mechacenia i pillingu
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                4
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Odporność na tarcie suche
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                5
                            </div>
                        </div>
                        <div className="TechnicalCardModal__table-row">
                            <div className="TechnicalCardModal__table-label">
                                Odporność na tarcie mokre
                            </div>
                            <div className="TechnicalCardModal__table-val">
                                4 - 5
                            </div>
                        </div> */}
                    </div>

                </div>
                <div className="col-12 col-md-4">
                    {category?.thumbUrl ? (
                        <img className="radius-3" src={category.thumbUrl} alt="" />
                    ) : <img className="radius-3" src={placeholderImageUrl()} alt="" />}
                </div>
            </div>


            {
                category?.pdfUrl && store.lang.current === 'pl' ? (

                    <InfoBar icon={null} className="a-start w-100 w-lg-50 mb-0">
                        <div className="row a-center">
                            <div className="col-12 py-1 pb-2">
                                <span dangerouslySetInnerHTML={{ __html: _t('fabric_info_question') }} /><br />

                            </div>
                            <div className="col-12 py-1">

                                <Button
                                    onClick={e => {

                                        window.open(category?.pdfUrl, '_blank');
                                    }}
                                    className="primary text-center">
                                    {_t('download_pdf_file')}

                                </Button>
                            </div>


                        </div>

                    </InfoBar>
                ) : null
            }




        </Modal>
    )
});

export default TechnicalCardModal